import { render, staticRenderFns } from "./repositoryList.vue?vue&type=template&id=4409796b"
import script from "./repositoryList.vue?vue&type=script&lang=js"
export * from "./repositoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports